<template>
  <v-container :class="containerClass" fluid>
    <v-row>
      <v-col cols="12">
        <v-data-table
          :headers="headers"
          :items="itemList.data"
          :loading="isLoading"
          :options.sync="options"
          :server-items-length="itemList.meta.total"
          :footer-props="defaultDataTableFooterProps"
          item-key="id"
        >
          <template #top>
            <v-sheet>
              <v-container fluid class="pa-4">
                <v-row align="center">
                  <v-col md="6" cols="12">
                    <h2>Lesson Category List</h2>
                  </v-col>
                  <v-col md="6" cols="12" class="text-right">
                    <v-btn
                      color="primary"
                      class="mx-1"
                      :small="$vuetify.breakpoint.mobile"
                      @click="showAddDialog"
                    >
                      <v-icon :small="$vuetify.breakpoint.mobile" left
                        >mdi-plus</v-icon
                      >Tambah
                    </v-btn>
                    <v-btn
                      class="mx-1"
                      :small="$vuetify.breakpoint.mobile"
                      @click="showFilters = !showFilters"
                    >
                      <v-icon :small="$vuetify.breakpoint.mobile" left
                        >mdi-filter</v-icon
                      >{{ showFilters ? 'Hide' : 'Show' }} Filter
                    </v-btn>
                  </v-col>
                </v-row>
              </v-container>
            </v-sheet>
            <v-divider></v-divider>
            <v-expand-transition>
              <v-sheet v-show="showFilters" color="grey lighten-5">
                <v-container fluid class="pa-4">
                  <v-row>
                    <v-col md="2" cols="12">
                      <div class="label mb-2">Name</div>
                      <v-text-field
                        v-model="filters.name"
                        outlined
                        solo
                        flat
                        background-color="white"
                        label="Name"
                        hide-details
                        dense
                        clearable
                        @change="getListData"
                        @click:clear="getListData"
                      />
                    </v-col>
                  </v-row>
                </v-container>
                <v-divider></v-divider>
              </v-sheet>
            </v-expand-transition> </template
          >s
          <template #[`item.created_at`]="{ item }">
            {{ formatDate(item.created_at, 'YYYY-MM-DD HH:mm:ss') }}
          </template>
          <template #[`item.updated_at`]="{ item }">
            {{ formatDate(item.updated_at, 'YYYY-MM-DD HH:mm:ss') }}
          </template>
          <template #[`item.action`]="{ item }">
            <div class="text-right">
              <v-btn
                small
                color="warning"
                class="ma-1"
                :icon="$vuetify.breakpoint.mobile"
                @click="showEditDialog(item)"
              >
                <v-icon small>mdi-pencil</v-icon>
                <span v-if="!$vuetify.breakpoint.mobile">&nbsp;Edit</span>
              </v-btn>
              <v-btn
                small
                color="error"
                class="ma-1"
                :icon="$vuetify.breakpoint.mobile"
                @click="showDeleteDialog(item)"
              >
                <v-icon small>mdi-delete-forever</v-icon>
                <span v-if="!$vuetify.breakpoint.mobile">&nbsp;Delete</span>
              </v-btn>
            </div>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
    <lesson-category-form-dialog
      v-if="formDialog.show"
      v-model="formDialog.show"
      :category="formDialog.item"
      :mode="formDialog.mode"
      @submit="onSubmit"
    >
    </lesson-category-form-dialog>
    <lesson-category-delete-dialog
      v-if="deleteDialog.show"
      v-model="deleteDialog.show"
      :category="deleteDialog.item"
      @delete="getListData"
    >
    </lesson-category-delete-dialog>
  </v-container>
</template>
<script>
import LayoutDashboard from '@layouts/Dashboard'
import { mapGetters, mapActions } from 'vuex'
import LessonCategoryFormDialog from '@components/LessonCategory/FormDialog'
import { ListParams } from '@/models'
import utils from '@/utils'

export default {
  name: 'LessonCategory',
  components: { LessonCategoryFormDialog },
  layout: LayoutDashboard,
  data() {
    return {
      headers: [
        { text: 'Name', value: 'name' },
        { text: 'Name (Chinese)', value: 'name_cn' },
        { text: 'Created At', value: 'created_at' },
        { text: 'Updated At', value: 'updated_at' },
        { text: 'Action', value: 'action', sortable: false, align: 'center' },
      ],
      options: {
        page: 1,
        itemsPerPage: 10,
      },
      showFilters: true,
      filters: {
        name: null,
        created_at: [],
        updated_at: [],
      },
      deleteDialog: {
        show: false,
        item: null,
      },
      formDialog: {
        show: false,
        item: null,
        mode: 'add',
      },
    }
  },
  computed: {
    ...mapGetters({
      itemList: 'lessonCategory/list',
      isLoading: 'lessonCategory/isListLoading',
    }),
  },
  watch: {
    options: {
      deep: true,
      handler() {
        this.getListData()
      },
    },
  },
  methods: {
    ...mapActions({
      getItemList: 'lessonCategory/getList',
    }),
    getListData() {
      const listParams = new ListParams(this.filters, this.options)
      this.getItemList(utils.toServerSideQuery(listParams))
      this.setListParams(listParams)
    },
    showDeleteDialog(item) {
      this.deleteDialog.item = item
      this.deleteDialog.show = true
    },
    showAddDialog() {
      this.formDialog.mode = 'add'
      this.formDialog.item = null
      this.formDialog.show = true
    },
    showEditDialog(item) {
      this.formDialog.mode = 'edit'
      this.formDialog.item = item
      this.formDialog.show = true
    },
    onSubmit() {
      this.formDialog.show = false
      this.formDialog.item = null
      this.getListData()
    },
  },
}
</script>
